<div class="content-creation-wrapper">
  <!-- Sub-tabs: Article | Social Content Analysis -->
  <div class="content-creation-sub-tabs">
    <button
      mat-button
      [class.active]="contentCreationSubTab === 'article'"
      (click)="contentCreationSubTab = 'article'">
      Article
    </button>
    <button
      mat-button
      [class.active]="contentCreationSubTab === 'social'"
      (click)="contentCreationSubTab = 'social'">
      Social Content Analysis
    </button>
  </div>

  @if (contentCreationSubTab === 'article') {
    <app-content-creation-article-tab></app-content-creation-article-tab>
  }

  @if (contentCreationSubTab === 'social' && hasData()) {
<div class="content-creation">
    <!-- Header -->
    <div class="header">
      <h2>Content Creation Analysis - {{ data?.brand || 'Brand' }} Strategy</h2>
      @if (getOverallContentScore()) {
      <div class="overall-score">
        <span class="score-label">Overall Content Score:</span>
        <span class="score-value" [ngClass]="getScoreClass(getOverallContentScore())"
          [style.color]="getScoreColor(getOverallContentScore())">
          {{ getOverallContentScore() }}/100
        </span>
      </div>
      }
    </div>

    <!-- Platform-Based Content Analysis -->
    @if (data?.platform_analysis) {
    <div class="platform-analysis">
      @for (category of getPlatformCategories(); track category) {
      <div class="platform-category">
        <h3 class="platform-category-title">{{ category }}</h3>
        <div class="platform-grid">
          @for (platform of getPlatformsByCategory(category); track platform) {
          <app-platform-content-card
            [platform]="platform"
            (generateContent)="generateContent($event)">
          </app-platform-content-card>
          }
        </div>
      </div>
      }
    </div>
    }
  
    <!-- Content Recommendations Summary -->
    @if (getTransformedRecommendations().length > 0) {
    <app-evidence-and-recommendations
      [recommendations]="getTransformedRecommendations()"
      [evidenceSources]="[]"
      [recommendationsTitle]="'Content Creation Recommendations'"
      [evidenceTitle]="'Data Sources & Evidence'"
      [showEvidence]="false"
      [showRecommendations]="true">
    </app-evidence-and-recommendations>
    }

    <!-- HIDDEN: Data Sources & Evidence (do not remove)
    @if (getCitations().length > 0) {
    <app-citation-card [citations]="getCitations()" [title]="'Data Sources & Evidence'" [displayStyle]="'grid'"
        [maxDisplay]="6">
    </app-citation-card>
    }
    -->
  
    <!-- Legacy Brands Content Analysis (Fallback) -->
    @if (!data?.platform_analysis && data?.brands) {
    <div class="brands-section">
      @for (brand of data.brands; track brand) {
      <div class="brand-card">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ brand.name }}</mat-card-title>
            <mat-card-subtitle>Content Score: {{ brand.content_status?.content_score || 0 }}/100</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <!-- Content Types Breakdown -->
            @if (brand.content_status?.content_types) {
            <div class="content-types">
              <h4>Content Types</h4>
              <div class="content-type-grid">
                @for (type of brand.content_status.content_types; track type) {
                <div class="content-type-item">
                  <div class="type-header">
                    <span class="type-name">{{ type.type }}</span>
                    <span class="type-count">{{ type.count }} pieces</span>
                  </div>
                  <mat-progress-bar [value]="type.quality_score" [color]="getQualityColor(type.quality_score)">
                  </mat-progress-bar>
                  <div class="type-quality">Quality: {{ type.quality_score }}%</div>
                </div>
                }
              </div>
            </div>
            }
  
            <!-- Competitive Gaps -->
            @if (brand.competitive_gaps && brand.competitive_gaps.length > 0) {
            <div class="competitive-gaps">
              <h4>Competitive Gaps</h4>
              <div class="gaps-list">
                @for (gap of brand.competitive_gaps; track gap) {
                <div class="gap-item">
                  <div class="gap-header">
                    <span class="gap-type">{{ gap.content_type }}</span>
                    <span class="gap-priority" [class]="'priority-' + gap.priority?.toLowerCase()">
                      {{ gap.priority }}
                    </span>
                  </div>
                  <div class="gap-details">
                    <div class="gap-current">Current: {{ gap.current_status }}</div>
                    <div class="gap-percentage">Gap: {{ gap.gap_percentage }}%</div>
                  </div>
                  @if (gap.recommendations) {
                  <div class="gap-recommendations">
                    <h5>Recommendations:</h5>
                    <ul>
                      @for (rec of gap.recommendations; track rec) {
                      <li>{{ rec }}</li>
                      }
                    </ul>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }
  
            <!-- Content Recommendations -->
            @if (brand.recommendations && brand.recommendations.length > 0) {
            <div class="content-recommendations">
              <h4>Content Recommendations</h4>
              <div class="recommendations-list">
                @for (rec of brand.recommendations; track rec) {
                <div class="recommendation-item">
                  <div class="recommendation-header">
                    <span class="content-type-badge">{{ rec.content_type }}</span>
                    <span class="piece-type-badge">{{ rec.piece_type }}</span>
                    <span class="impact-score">Impact: {{ rec.impact_score }}/100</span>
                  </div>
                  <h5 class="recommendation-title">{{ rec.title }}</h5>
                  @if (rec.keywords) {
                  <div class="recommendation-keywords">
                    <mat-chip-set>
                      @for (keyword of rec.keywords; track keyword) {
                      <mat-chip>{{ keyword }}</mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                  }
                  <div class="recommendation-footer">
                    <span class="estimated-effort">Effort: {{ rec.estimated_effort }}</span>
                  </div>
                </div>
                }
              </div>
            </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
      }
    </div>
    }
</div>
  }

  @if (contentCreationSubTab === 'social' && !hasData()) {
    <div class="content-creation content-creation-empty">
      <p>Run Content Creation analysis to see Social Content Analysis (platform recommendations, generate content).</p>
    </div>
  }
</div>

<!-- Content Generation Popup -->
<app-generic-content-generation-popup 
  [recommendation]="getRecommendationForPopup()" 
  [isVisible]="showContentGenerationPopup"
  (close)="closeContentGenerationPopup()">
</app-generic-content-generation-popup>

  